import { createSelector } from 'reselect'

import type { AppState } from '~/reducers'
import type { GuestProfile } from '~/types'

const getProfile = (state: AppState): GuestProfile => state.profile

export const isRestrictedAccount = createSelector(
  getProfile,
  (profile) => profile.ageRestricted,
)
